module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("The BEF in 1917")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle1"
  }, [_vm._v("Arras, Vimy, Messines, Passchendaele and Cambrai")]), _vm._v(" "), _c('p', {
    staticClass: "noindent ts18"
  }, [_vm._v("Following the almost intolerable pressure exerted on the German armies by the Anglo-French Somme offensive that had dominated the second half of 1916 on the Western Front, there was little option for the numerically inferior German forces other than to save manpower by eliminating the resultant salient by straightening their lines. As a result, the Hindenburg (or Siegfried) Line of defences was constructed some thirty miles behind much of the German front line. On 9 February 1917 German troops gradually began the withdrawal to the new line, completed on 5 April 1917. They left behind a swathe of devastated territory, with advancing allied troops having to tackle numerous booby traps that, combined with judicious use of a rearguard, meant that the allied advance had to be very cautious. This withdrawal also had a considerable impact on the proposed French grand strategy for 1917, which had anticipated attacking both flanks of the Noyon salient.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("Despite the doubts over the operational value of the Somme offensive, the British concluded, with some justification, that the German withdrawal resulted directly from the casualties that the Germans had suffered during the Battle of the Somme. This pointed towards the fact that, strategically, a policy of attrition could be a war-winning strategy on the Western Front; a viewpoint that was shared by all the major combatants. In consequence, a series of major offensives, which rippled gradually northwards towards Ypres, were conducted by the British throughout much of 1917. These offensives were to culminate in the Battle of Cambrai.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("In 1917 the idea of a campaign in Flanders was certainly controversial and has remained so ever since. The British Prime Minister, Lloyd George, opposed the offensive, whilst the French approved but made clear their own problems with morale in the army after the relative failure of the Nivelle Offensive. The British commander, Field Marshal Sir Douglas Haig, championed the idea of a Flanders offensive, but crucially did not receive approval for the full Flanders operation from the War Cabinet until 25 July 1917. The controversy has continued since the war, with a key argument being that the decisive offensive should be delayed until the arrival of the Americans in force in France (which rather assumed that the Germans would wait as well; their own strategic options were widened by the political turmoil in Russia). Flanders competed with other options put forward for 1917, such as a renewed offensive in Picardy or even a shift to the Italian front. The choice of General Hubert Gough and his Fifth Army to conduct the offensive was and continues to be controversial. The time that was allowed to elapse between the Battle of Messines and the opening attack of the Battles of Ypres has also been a source of criticism; although the realities of logistics (for example the shortage of railway stock and the need to re-lay lines for the offensive, not to mention political indecision, goes a long way to explaining the delay).")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("Nivelle’s grandiose offensive plan opened the campaigning season; by 1917 the size of the British Army on the Western Front had grown to two-thirds the total numbers in the French armies, yet the French still largely called the shots of allied grand strategy. Somewhat reluctantly, Haig agreed to launch an offensive around Arras to operate in conjunction with the French attacks on the Aisne and Champagne. The British attack was launched a week or so earlier than that of the French, on 9 April 1917, and, in contrast to the opening day of the Somme, had some notable success, with considerable advances made, especially to the north and east of Arras, most notably by the taking of the length of Vimy Ridge and, famously, its northern and highest part by the Canadian Corps and the British 5th Division. However, the Germans recovered rapidly from the initial setbacks and the battle – continued far longer than Haig had either anticipated or wished because of setbacks in the French attack – culminated towards the end of May in a bloody draw, with casualties on a daily basis far higher than they had been on the Somme the previous year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("On 7 June 1917 the British focus moved north towards the battle-torn town of Ypres, which had been the focus of fierce fighting since October 1914. The attack on the high ground centred on Messines Ridge, south of the town, was an essential prequel to the much greater offensive, both in size and strategic objectives, that followed, the Third Battle of Ypres or, as it is more popularly (though misleadingly) known, the Battle of Passchendaele.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("The Battle of Messines was designed to take the high ground on which the Germans had established themselves during the First (October–November 1914) and Second (April–May 1915) Battles of Ypres. With the high ground captured, the Germans would be deprived of much of their capacity to fire their artillery in enfilade (i.e. from the side or flank) against the forthcoming British attack heading eastwards from Ypres, in particular the Gheluvelt plateau.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("Since 1915 Royal Engineer tunneling companies had been digging tunnels under the ridge and about 500 tonnes of explosives had been positioned in twenty four mines under the enemy lines: in fact the potential to blow the mines had existed for months prior to June 1917 and their use had been proposed in September 1916 as a diversion from the final phase of the allied offensive on the Somme.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("Following four days of preliminary bombardment, nineteen of these mines were successfully detonated, though the much-quoted figure of 10,000 German troops killed in the blast is a considerable exaggeration. The shock effect of the mines’ blast was complimented by a heavy bombardment, conducted far more effectively and scientifically than on the Somme by a now much more experienced, better equipped and larger Royal Artillery, allowing the BEF to capture the major part of the Ridge in the opening day. The limited offensive, commanded by General Plumer, lasted only two weeks and can be considered a considerable success. German counter-attacks were contained and the southern flank of the Gheluvelt plateau was henceforth protected from direct German observation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("Although gas shells had been available for some time, the limited size of an artillery shell required that a more potent gas had to be deployed if such a method of delivery was to be of significant effect; so, from September the Germans employed mustard gas (also known as Yperite), a powerful blistering agent. The artillery deployment allowed heavy concentrations of the gas to be used on selected targets. Mustard gas was also a persistent agent which, dependent upon weather conditions, could linger for up to several days in a particular area, an additional demoralising factor for their opponents. Along with phosgene, mustard gas would be used extensively by both German and Allied forces in later battles as the Allies also began to increase their own production of gas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("After a short break, which allowed the Germans to regroup and reorganise, the Battle of Third Ypres opened on 31 July and continued to 10 November 1917. The strategic objective was to deprive the Germans of the key railway junction at Roulers and from there to roll up German forces (in conjunction with an imaginative and highly ambitious amphibious assault) along much of the Belgian coast and thus deprive German submarines – by then inflicting almost lethal damage to British merchant shipping and thus Britain’s essential lifeline – of their bases there. The immediate aim was to capture the high ground that had dominated the allied line around Ypres since the line had settled down in the late autumn of 1914.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("Passchendaele lay on the last of these dominating ridges east of Ypres, just six miles from the vital railway junction at Roulers, essential to the supply system of the German Fourth Army. The next phase of the Allied attack was an advance to the north, to the line Thourout–Couckelaere, to close the railway running between Roulers and Thourout (which did not take place until the autumn of 1918). Further operations and a British supporting attack along the Belgian coast from Nieuwpoort, combined with an amphibious landing (Operation Hush), were intended to reached Bruges and, at their most optimistic, the Dutch frontier. A highly successful German limited attack at Nieuwpoort in mid-July effectively foiled plans for the attacks on the coast, whilst the heroic resistance of the German Fourth Army, unusually wet weather, the onset of winter, and the diversion of British and French resources to Italy following the Austro-German victory at the Battle of Caporetto, enabled the Germans to avoid the general withdrawal that had seemed inevitable in early October. The offensive officially ended on 10 November, shortly after the Canadian Corps captured Passchendaele on the 6th, with the exception of some local attacks in December and into the New Year. In 1918, the Battle of the Lys (a major German offensive in April) and the Fifth Battle of Ypres (which commenced in September) were fought before the Allies finally occupied the Belgian coast and reached the elusive Dutch border.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("The Passchendaele offensive dragged on through a horrendously wet August, through a very dry September and then into a dreary and wet autumn. The battle was fought from flooded trenches and shell holes in the most appalling conditions of mud, freezing water, rain and cold. Finally, despite extremely heavy rain and considerable casualties, Canadian veterans from Vimy Ridge and Hill 70, under Plumer’s Second Army, relieved the two Anzac Corps and British troops in mid October and, on 6 November, at last took the large village of Passchendaele; meanwhile, to the north, Gough’s Fifth Army and French troops inched their way towards the prize of Houthulst Forest (which they did not reach, however).")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("The offensive resulted, once again, in a huge number of casualties on both sides (but at a significantly lesser daily casualty rate than the Somme and Arras) for relatively little gain of ground – apart from the more secure line before Ypres and potentially a better platform for an offensive in the spring of 1918, little of strategic value – fought against dogged German resistance; yet that captured was of considerable tactical importance and the British made inexorable gains during periods of drier weather. The ground was appallingly muddy, wet and pocked by shell craters, making supply, redeployment of the artillery forward and further advance very difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("Both sides suffered a combined total of well over 500,000 casualties during this offensive. The battle has become a byword among some British historians for bloody and futile slaughter, whilst one German called Passchendaele ‘the greatest martyrdom of the War’. It is one of the two battles (the other is the Battle of the Somme) that have done most to earn British Commander in Chief, Sir Douglas Haig, his controversial reputation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts18"
  }, [_vm._v("But 1917 was not yet over: at Cambrai, in late November, the mass deployment of tanks and a sophisticated artillery programme showed signs of things to come; whilst the German counter-offensive was a harbinger of events in the spring of 1918.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page10.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("All washed and cleaned up, this soldier is enjoying playing up for the benefit of the camera. Such images were important in maintaining the morale of those at home.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page11.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("Even away from the front line the conditions nearby were often poor. Canadian troops queuing for a meal in the Ypres Salient.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page12.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("In relative security, a machine gun team works on maintaining their Vickers. Keeping weapons clean and therefore immediately available for action was always a problem in the trenches, never more so than in the winter months.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page13_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Members of the Canadian Corps enjoying a lighthearted moment some distance from the front on the Somme. The latter stages of the Somme fighting, in November 1916, were a precursor of the conditions that faced both sides a year later during the Third Battle of Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page13_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The huge number of shells fired by both sides during the Battle of Third Ypres destroyed the delicate system of drainage ditches in the Salient. When this was combined with the cratering of the landscape the result made it extremely difficult to move artillery, rations and men.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page14.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The winter of 1916–17 was another harsh one; conditions in the trenches could become almost intolerable. Remarkably, the health of the armies on the Front stood up to the often atrocious conditions – though rarely were they as bad as pictured here.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page15.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("Bringing in a wounded soldier; the fact that everyone looks reasonably happy is that they would appear to be out of immediate danger. Stretcher bearers were provided both by appointed soldiers within an infantry battalion and by the Royal Army Medical Corps.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page16.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A sergeant oversees soldiers making up trench ladders in anticipation of the next attack. Note in the foreground on the right the distinctive 2 inch medium mortar bombs, with their lengthy (22 inch) shaft and 42 pound bomb. It gradually went out of use in 1917, though found a new value as an anti-tank mine in the last stages of the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page17_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A German bunker, captured by the Canadians, built into the corner of a house. Bunkers provided shelter for a variety of activities – from an observation post, a base for aid posts, shelter from shelling and, occasionally, for a machine gun. However, the preference during Third Ypres, for example, was that machine guns would operate from shell holes – bunkers provided a fairly distinctive target, especially once camouflage had been blasted away.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page17_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Steel observation posts were a fairly common feature of the Western Front by 1917. Often described as sniper posts, the reality was that snipers rarely – if ever – used such structures from which to operate.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page18.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A pack horse has its load of barbed wire pickets and other trench stores checked to ensure that they are secured. The photograph is a good illustration of the basic kit that an infantryman carried at this stage of the war – a sharp contrast to the Tommy of 1914.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page19_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British infantry heading eastwards over a canal during Third Ypres – judging by the number of shovels that they are carrying they are in for some hard work in the trenches.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page19_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A scene during the Battle of Passchendaele at the Yser Canal. Note the soldier in the right rear with his gas mask container hanging on his chest – gas shelling was a real threat. Note also the line of felled trees, possibly to make observed shelling of the canal more difficult.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page20_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("In the right distance a shell bursts on the Vimy battlefield, a desolate area that had been heavily fought over since the early days of the war. Note the barbed wire pickets in the foreground.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page20_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Reinforcements (including stretcher bearers) moving forward over captured terrain: especially to the north of the River Scarpe, the opening phase of the Battle of Arras had resulted in substantial territorial gains.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page21_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Initial success at Arras soon became bogged down in the face of staunch German resistance. These two British casualties serve to illustrate the increased cost of the offensive.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page21_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("General François Anthoine, GOC French First Army, which operated to the north of the British army at Third Ypres, decorates two British officers, Major Burkhardt and Captain Napier, with the Legion d’Honneur. The French soldier on the left is a member of the "), _c('span', {
    staticClass: "ts19"
  }, [_vm._v("chasseurs alpins")]), _vm._v(", mountain infantry.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page22.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Canadian troops celebrating the successful attack at Vimy Ridge. The condition of their boots and clothing, in what was a wet and muddy battlefield, suggests that these particular men are on their way up to the front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page23.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The horse and mule between them were the main means of transportation for artillery and ration resupply in the battle zone area for the whole war, even with the rapid mechanisation that took place. It is worth noting how significant these animals were in the Second World War – the German army used hundreds of thousands of them, for example. At the end of the day, the horse was the most reliable method from getting from A to B quickly; indeed, the lack of an effective cavalry in the German army in 1918 was at least a contributory factor – and arguably a significant one – in the failure to make a decisive breakthrough in the spring offensives of 1918.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page24_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Quietly enjoying a chat and a pipe, these two soldiers seem so nonchalant about where they are, with a shell going off in the near distance, that they might almost be sitting on a bench on a village green back in England rather than in very close proximity to an active battlefield.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page24_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("After the lessons from the First Day of the Somme, the medical services were well prepared to deal with the flow of casualties of the Battle of Messines. This is a dressing station in the forward area; note the German prisoner on the right, possibly being employed as a stretcher bearer.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page25.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("An unusual sight in 1917 – troops in the foreground move through a battery position, a tank dominates the middle ground and cavalry can be seen in the distance. The tank, once again, did not perform particularly well at Arras: its moment came at the Battle of Cambrai, in November.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page26.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("Fully equipped troops boarding a ‘London’ bus during the Battle of Arras. These buses had been requisitioned from the earliest days of the war for the transportation of troops; note that strapped on the back are a shovel and pick, ready for use should the vehicle get bogged down.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page27.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Dead German soldiers in a lane to the north east of Soissons, casualties in the Second Battle of the Aisne (better known as the Chemin des Dames), 16 April – 9 May 1917. Although modest gains were made, the German line was only moved back marginally and the advance was certainly not proportionate to the heavy casualties that were suffered. The British fought the Battle of Arras (reluctantly) in support of the French offensive and continued it for a longer period than intended because of its failure to achieve the high expectations that had been raised by General Nivelle, the French commander in chief. A major consequence of the battle was multiple acts of ‘disobedience’ in the French army.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page28.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("All sorts of devices were used to enable observation across No Man’s Land. In this case a metal ‘tree’ has been constructed as an Observation Post. Note the waders being worn by the occupant: this post would almost certainly have been in a low lying part of the front, such as Flanders.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page29.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Canadian soldiers pass a tank as they move forward after the successful storming of Vimy Ridge.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page30.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The devastation caused by fierce and lengthy fighting is starkly illustrated by this photograph of the western approaches to what once had been the village of Pozières, a victim of the Somme 1916.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page31.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Most of Arras remained in allied hands throughout the war, but many of its houses fell victim to the persistent shelling of the city. The destruction of one house leaves its neighbour exposed, revealing the contents of some family’s home.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page32_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Members of the Cyclist Corps working on their bikes, with a shell falling rather too close for comfort. Although the use of bicycles in warfare might appear somewhat comical to us today, it was often an efficient way of moving men about.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page32_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Men of the 51st (Highland) Division moving forward to the attack. The Division attacked (successfully) on the Canadian Corps’ right flank on 9 April 1917.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page33.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("An advanced dressing station, where essential medical attention was given before a wounded soldier was moved further to the rear or returned to duty. The soldier being treated by the doctor is a member of a tank crew.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page34.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Control of the heights of Vimy Ridge had led to major French offensives, especially in spring and autumn 1915 (the battles of Artois). Underground warfare had been a feature of the fighting from the earliest days; after September 1915 this continued, reaching a peak of over 100 mines fired in June 1916 alone. By the time of its capture on 12 April 1917 its appearance had been transformed to that of a lunar landscape.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page35.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The lack of helmets suggests a picture taken earlier in the war; or one taken some distance from the line. Two officers enjoy a meal from their mess tins whilst under observation by their men. Note the rag covering the working parts of the rifle on the left; mud and grit has always been the enemy of the soldier’s personal weapon.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page36.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("By this stage in the war the soldier at the front was generally better equipped to deal with the foul conditions than his predecessors in the earlier years of the war; trench construction, for one, was far more robust.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page37.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("Behind the lines, probably near a rail head, gunners load ammunition limbers with shells for the artillery. This photograph gives some indication of the scale of the consumption of shells in major battles by 1917.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page38.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The British Expeditionary Force included formations from the Dominions, such as Canada, Australia and New Zealand. Here two severely injured members of the Canadian Corps (though one manages to smoke) are being transported down the line for further treatment at a Casualty Clearing Station.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page39.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("A British officer makes his way through mud, water and a scene of desolation: conditions that are closely associated with 1917 on the Western Front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page40.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("In a well constructed and maintained trench, a sentry makes use of the safety of a trench periscope to look over No Man’s Land. In quiet periods and sectors the greatest threat to the men in the front line often came from snipers.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page41.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The heap of ruins of the Chateau de Caulaincourt, a former German Corps HQ that they blew up as part of the withdrawal to the Hindenburg Line in the late winter/early spring of 1917. The soldiers are removing debris that was blocking the stream.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page42.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Preparations for the Battle of Arras: soldiers preparing trench ladders, necessary for the troops to move quickly forward for the assault from their jumping off trenches and through the gaps in their wire. By 1917, where practicable, it was common for the first wave of attackers to be pre-positioned in No Man’s Land – though the practice was in use in some cases on the Somme on 1 July.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page43.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("In contrast to the opening days of the Somme, the British offensives of 1917 were well supported by a very substantial number of guns; in particular there were far more heavy weapons. Here, in April 1917, men of XCI Battery, Royal Garrison Artillery, prepare to fire their 9.2 inch howitzer. Notice the camouflage netting and the array of prepared shells.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page44_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Troops from a London division making their way through a destroyed village in Flanders.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page44_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British soldiers leaving their billets in a badly shelled village to the north of Ypres, probably Boesinghe.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page45.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British troops getting into a train’s freight carriage (‘huits chevaux/quarante hommes’ is often seen pictured chalked on their French equivalents) after a tour of duty on the Flanders front. It appears to be raining quite hard – the summer of 1917 was, notoriously, very wet in the Salient.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page46.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Reinforcing troops pause in a makeshift trench during the advance at Arras, near Tilloy. They are equipped with shovels and pick axes, so it would seem that they can look forward to some strenuous digging in the new line.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page47.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("A line of French trenches running through a destroyed wood on the battlefield of the Chemin des Dames, one of the major areas included in Nivelle’s fateful offensive. Whilst achieving some moderate gains, it failed to live up to his promises. After almost three years of relentlessly heavy fighting, the morale of the French army dropped almost to breaking point, though the situation was largely corrected by the appointment and subsequent actions of a new commander, Pétain.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page48.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British troops crossing a solidly built pontoon bridge on their way to the front. The remains of the original bridge, destroyed by the Germans in their withdrawal, can be seen on the right.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page49.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("It would have taken a mighty shell to dislodge this bunker from its foundations. Valuable as shelters, bunkers were in many ways death traps, as they became the focus point of enemy fire. Occupants were more vulnerable to death by concussion than by the outright destruction of the structure.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page50.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("On 9 April, the first day of the Arras offensive, considerable gains of up to three miles were made for relatively small – though still considerable – loss. Pictured here are men who have been relieved at the new front line, threading their way back through British wire.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page51.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British and French artillery observers watching and directing fire (note the telephonist, left rear), making use of the shelter provided by a bunker. The French First Army operated on General Gough’s left during Third Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page52.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("In the relative shelter of a deep dugout (note how well secured the roof has been made), medical personnel of the Australian Imperial Force give immediate aid to wounded troops. Once this has been done, the wounded were evacuated (often a dangerous and uncomfortable process) further behind the lines to Casualty Clearing Stations and Stationary Hospitals for more intensive medical attention. Cases that required longer term care were then moved back to Base Hospitals or to Britain.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page53.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("7 August 1917 – Irish Guardsmen moving up to the front from the rear areas, protected by a wattle fenced bank, providing relatively secure cover from enemy observation and fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page54.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("September 1917 proved to be a dry month, with the men complaining almost as loudly about the dust as they had about the rain of the previous month. A stretcher party moves up to the line over a hastily created trail, using duckboards to create an easier route. Relatively easy in daylight, trying to follow such pathways during the night was a considerable challenge.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page55.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("Wounded soldiers being treated in an Australian Dressing Station in a dugout by the Menin Road.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page56.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Limbers passing through the ruins of Athies, a front line village near Arras, on the north bank of the River Scarpe. Like so many other villages in the war zone, it was – effectively – completely destroyed during the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page57.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("20 September 1917 – Wounded British soldiers brought back from the line to an Aid Post at the opening stages of the Battle of the Menin Road, the third phase of the Third Battle of Ypres. Note that German prisoners are being employed as stretched bearers.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page58.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Although the historic centre of Arras was never held by the Germans, it suffered considerable damage as the line ran close to its eastern and southern limits. A visitor today will see what a painstaking restoration of this part of the city took place after the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page59.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("This group (largely of officers of the Inniskilling Fusiliers), relaxing after their part in the opening of the Messines offensive, playing up for the camera with items of captured German equipment.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page60.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Members of a Highland battalion are laid out for burial.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page61.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("18 August 1917 – The second phase of the Battle of Third Ypres was launched at Langemarck on 16 August and slithered to a bloody halt in that dreadfully wet August. The photograph illustrates the problem of congested roads covered in the ubiquitous mud, whilst working parties of infantry move forward to consolidate the meagre gains that had been made.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page62_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British and French soldiers on the Ypres battlefield. It is often forgotten that the French army was also engaged in the Third Battle of Ypres. Its First Army operated on the left flank of the British Fifth Army, at the northern end of the attack front; and suffered some 9,000 casualties.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page62_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Members of a tank crew pose for the camera – the soldier in front implying that he is holding the tank upright with the use of his arm. Tanks were still in their infancy in 1917, although design improvements came rapidly. They were slow, unwieldy, extremely uncomfortable for the crew and vulnerable to field artillery – but also proved their worth at trampling barbed wire and dealing with nests of resistance. They did not perform particularly well in 1917 until their mass use at Cambrai in November.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page63_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("(Left) Troops, guns and supplies moving forward to the front from a position well behind the front line by foot and by bus. (Right) A view from a shattered building in Ypres over the wreckage of a town that had been a jewel of medieval architecture before its destruction.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_vm._v("5 October 1917 – five members of the 8th Battalion East Yorkshire Regiment on Frezenberg Ridge in the immediate aftermath of the Battle of Broodseinde, 4 October 1917. The stark clarity of the soldiers in silhouette make this one of the classic images of the war.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page63_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page64_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The dry weeks of September were followed by a very wet October and November: the fighting continued, however, unabated, as slow progress was made towards the village of Passchendaele and the dominating ridge upon which it stood.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page64_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Bridges were usually an early victim of any advance, as a retreating enemy would blow them to delay any advance. They could usually be repaired quite quickly – but were thereafter vulnerable to enemy shell fire, as their position was clearly established on the map.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page65.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("A scene some distance behind the line (note that several of the soldiers are not wearing their steel helmets). The men are engaged in battlefield clearance – the felled trees, the result, probably, of shell fire, would be stripped down and used for road making, dugout or tunnel props or, at worst, fire wood. Ample supplies of timber were a vital requirement during the war and hundreds of troops and civilians were employed to keep the armies supplied.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page66_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A ruined lock on the Ypres Canal, the historic economic lifeline of the city and its route to the North Sea. The canal was an important barrier in halting the German advance in both 1914 and 1915.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page66_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Troops being transported behind the lines for rest and recuperation. Divisions were often withdrawn from the line for several weeks to rebuild and retrain after prolonged operations and having suffered heavy casualties.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page67.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British soldiers passing under a barricade built up of barrels and boxes in a communication trench dug alongside the houses of a French village. Note that some of the soldiers have covered their rifle barrels with sacking and a number are carrying shovels. Tours of duty in the trenches would inevitably involve their maintenance.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page68.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("A principal task for every soldier is keeping his personal weapon clean and ready for immediate action. In the foreground the soldier seated in the middle seems to be looking dejectedly at the sorry state of his rifle; whilst all around men are similarly engaged in cleaning and oiling their weapons.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page69.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A soldier hits the ground as a shell goes off in the middle distance. Incessant shell fire over three years of fighting in the Salient, especially during Third Ypres, had turned the landscape into a desolate wilderness, leaving troops with little in the way of cover. Note that the road has been made from (or reinforced by) thick lengths of wood, often known as corduroy roads.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page70.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Reorganising the army for its next push was a laborious job in the conditions in Flanders that summer. One of the main problems was bringing the artillery forward, illustrated here by the large gang of men needed to haul a heavy piece through the battle-tortured terrain.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page71.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Walking wounded making their way to the rear past a dressing station on the Menin Road.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page72.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("18 August 1917 – The offensive grinds relentlessly on. After the failure of the Battle of Langemarck in mid August, General Plumer’s Second Army was brought into action along the southern half of the battle’s front. The chaotic conditions caused by the weather, battle damage and the limited number of roads in this rural part of Belgium are clearly illustrated in this stunning photograph.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page73.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("September 1917 – A section of Australian infantry in a communications trench, bayonets fixed and wearing their small box respirator gas masks. The Australians played a prominent part in the attacks of Plumer’s Second Army along the Menin Road. Note the bunker in the middle distance, with infantry sheltered on the side furthest from the enemy.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page74.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Still stuck firmly in the mud, the water cart driver is left with no choice but to unhitch the horses and will probably have to rely on helpful infantry nearby to get the cart back on to solid ground.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page75.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("This picture speaks for itself; a solitary figure picks his way through a sodden, shell-cratered landscape that has been made all but featureless by the incessant shelling.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page76.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A group of German officers, possibly a battalion or regimental staff, under the guard of a Highland soldier. The right-hand wall of the damaged bunker shows the amount of reinforcing steel used in its construction.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page77_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A soldier inspects a captured German strongpoint near Lens, possibly taken during the successful Canadian Corps action at Hill 70 in August. Note the steel girders used in its construction; the Germans employed a huge workforce of troops and forced labour civilians in building these concrete bastions of the battlefield.")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_vm._v("A soldier peers through an armoured shield that has been incorporated into this concrete work, which would have provided protection for sentries as they scanned the battlefield.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page77_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page78.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Supply wagons bringing up shells, feeding the insatiable appetite of the guns. The appalling conditions on the Ypres battlefield are clearly apparent. Haig continued the Battle of Third Ypres despite the sodden mess of the terrain; there was a strategic rationale to his decision, but many of his senior commanders advised that the effort and cost was no longer worth the potential gain.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page79.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("As the war progressed trench raids became evermore common and their execution more sophisticated. In response, both sides sought to limit the success of any such raid by adopting new defensive measures, such as this barbed wire gate that could be dropped across a trench in case of emergency.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page80_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Communications were the weakest link in the command system in the war. Light signalling was employed by all sides, but it had all sorts of weaknesses: for example, the exposure of the operator and the fact that battlefield smoke could obscure any message being transmitted.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page80_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A group photograph of soldiers from a battalion of a Surrey regiment in a position east of Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page81.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("A sergeant peers cautiously over the parapet of a hastily constructed trench. Although the soldiers appear quite relaxed, their bayonets are fixed, which indicates that they are in an active zone of the front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page82_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("This photograph was taken during a dry day during Third Ypres: September was unusually dry and there were complaints for a change about the clouds of dust rather than the mud. The artillery’s problem is clearly illustrated: bringing guns forward was a hugely difficult task.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page82_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("German soldiers lose dignity in death; the legs of a dead British soldier can be seen at the right bottom edge.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page83_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("17 July 1917 – British soldiers observing artillery shells bursting in the area of Bullecourt (closely connected with the Australians), at the southernmost part of the Arras offensive, which had ended a couple of months earlier.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page83_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Railway lines and rolling stock were still in short supply in the British sector; here British troops are engaged in preparing new track in the country west of Boesinghe, in preparation for the launch of the Flanders offensive on 31 July.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page84_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Cavalry moving through yet another destroyed French township. Cavalry played no significant role on the Western Front in 1917 – the most notable event was an extremely expensive cavalry action at Monchy le Preux, in the early days of the Battle of Arras.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page84_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A British soldier looks across the devastated battlefield near Ypres; a destroyed, water-filled trench and bunker and, in the distance, a bursting shell, which he appears to ignore. Scenes such as this, after three long years of struggle, had a significant impact on the morale of all the combatant armies.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page85.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("In a landscape seemingly comprised of little more than water and mud, these German bunkers, photographed in October 1917, provide the only signs of solidity and human habitation.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page86_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A large wagon transports the better part of thirty men through a wrecked village in an area close to the front. Amongst the various discomforts of bad weather could be added the dust thrown up by such vehicles and the bone-jarring ride. However, a lift is a lift and would make a welcome change for soldiers accustomed to depending on their own two feet to move from place to place.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page86_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Tired soldiers having some time for a break and a cigarette. Note the barbed wire pickets, rolls of barbed wire and tools, significant of consolidation work ahead. In fact the NCO looks as though he might be giving the men their instructions, about which they look less than enthusiastic.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page87_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Australian troops moving along a plank road on Westhoek Ridge near Idiots Corner.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page87_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A huge shell crater, 75 yards in circumference, in the Ypres Salient. Very heavy, or super heavy, guns were used by both sides; but they were very unwieldy, demanded considerable manpower to operate them and the shells were very expensive to produce. There was never a large number of them and they served more as a weapon that impacted on the enemy’s morale rather than a significant operational one.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page88.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The herculean efforts required of stretcher bearers in the dreadful conditions during the worst of the weather during Third Ypres are here graphically illustrated. Notice that it is taking no less than seven men to bring in a single casualty.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page89.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("Stretcher cases laid out on the ground, possibly at a Main Dressing Station. Most of the men lack helmets – therefore away from the front line – but the tentage does not seem to cover a big enough area for a Casualty Clearing Station. It is likely that the men on the stretchers in the foreground are waiting to be transferred down the line for further medical attention.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page90.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Passchendaele, late 1917. It is difficult to imagine how it was possible to conduct planned operations across a landscape as desolate as this; it would be bad enough merely trying to survive without the perils of being shot at or shelled.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page91.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("An artillery observation balloon, tethered to the ground, floats above the gaunt ruins of Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page92.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Forward Observation Officers (one with a periscope, another with binoculars) from the artillery operated as far forward as possible in order to direct the fire of their battery. This team is from the 12th (Eastern) Division, which was engaged south east of Arras.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page93.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("14 October 1917 – a scene behind the lines. New Zealand troops on the right of the road (note the distinctive ‘lemon squeezer’ hat worn by some of them), members of II Anzac Corps, march past a British battalion taking a break. Motorised and horse-pulled transport and a lone cyclist complete the picture of activity on the road, which is being viewed by curious observers on the right bank. Note that panels have been stretched between the trees on the left, the side facing the Germans, to obscure the visibility of their ground based artillery observers.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page94.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("It is said that a photograph is as good as a thousand words: a small party of three wounded, led by a stretcher case with two others following, along with another medic, thread their way across the battlefield. And yet some veterans considered that the last days of the Somme in November 1916 were even worse than this.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page95_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("King Albert of the Belgians, who commanded Belgium’s six very large divisions, which were stationed north of the British, from Dixmude towards the coast, taking the salute at a review of the Guards Division, autumn 1917.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page95_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("King Albert I inspects a Guard of Honour formed by men of the Australian Imperial Force.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page96.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The low-lying land of Flanders had required the development of a sophisticated system of drainage over the centuries to turn it into a highly productive agricultural area. When these ditches were destroyed in the fighting the effect was to turn the surrounding ground into a quagmire. Troops were thus given the thankless task of restoring them as best they could.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page97.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The Great War depended to a great extent on muscle power for the delivery of munitions and supplies of all types to the men at the front. A crucial element in the supply network was the mule, hundreds of thousands of which served with the armies on fronts all over the world.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page98.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Canadian troops of the 16th Battalion (the Canadian Scottish) CEF occupying hastily scraped out positions near Passchendaele. Note the Vickers gun on the left of the picture and the use of groundsheets to provide some basic cover against the elements on the top right.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page99.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Soldiers of the Australian X Field Artillery Brigade, 4th (Australian) Division make their way through Chateau Wood, near Hooge and the Menin Road, on a duckboard causeway in late October 1917.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page100.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("First aid is administered to a British soldier who has received a wound to his head.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page101.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Members of the 36th (Ulster) Division pass by trench supplies dumped by the roadside in the area of Pilckem shortly after the Battle of Third Ypres had opened. The Division suffered heavy losses during the Battle of Langemarck in mid August and whilst holding the line in the fortnight before that.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page102.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("12 October 1917 – This was the date of what is officially called the First Battle of Passchendaele; it was a battle that achieved little except to impose further misery on both sides. In amongst the detritus of war in this destroyed position can be seen the remains of two German soldiers.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page103.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("British soldiers doubling up by a captured bunker. The building has obviously taken a substantial number of hits from shells as the mass of exposed reinforcing steel rods indicates; however, it seems to have survived all of this and to be reasonably intact. What the weight of shell fire might have done to the occupants is another matter altogether.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page104.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Troops preparing for the launch of a new British offensive – this time down to the south, in front of the German held city of Cambrai. The offensive had been proposed some months before and planned by Third Army; Haig gave his consent to the plan so long as it was brought to a halt as soon as it ran into major difficulties.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page105.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("November 1917 – German prisoners are used to help to carry the wounded away from the front, whilst Canadian troops head in the opposite direction with much needed duckboards or trench mats: these were made of wood and with wire mesh overlaid on one side to help to strengthen them and to reduce the risk of slipping.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page106.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Sachsenfeste was a bunker complex in Rondell Wood (Oosttaverne Wood to the British) that was captured by the British during the Battle of Messines. Even today some of the bunkers associated with the German defences in the area are still standing.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page107_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British troops make themselves comfortable in what had recently been a German field fortification.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page107_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Relatively safe from the destruction of war, these large statues from the west front of a church in Arras have been removed to a church well behind the lines.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page108.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("When Passchendaele village finally fell to the Canadians on 6 November all that remained identifiable of what had once been a large and prosperous village was the outline of its large church, recognisable only by the smudges of red left from the shattered bricks. Here soldiers are marking out a route for the construction of a new track over what would otherwise be almost impassable country.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page109_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The village of Passchendaele some months before 1917 – and the same area at the close of the Third Battle of Ypres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page109_2.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page110.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("Lieutenant General Birdwood, commanding I Anzac Corps [Australian and New Zealand Army Corps], chatting with King Albert (wearing the uniform of colonel of an unidentified British regiment) during the latter’s formal visit to the British sector of the Western Front in the autumn of 1917.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page111.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("In the foreground pioneers (or possibly engineers) set about repairing a bridge and road during the advance in Flanders in the late summer of 1917; in the middle distance infantry pick their way through the shattered terrain on their way to the front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page112.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British cavalry rides over a trench in the lead up to the opening of the Battle of Cambrai on 20 November 1917. Cambrai is particularly remembered for the first mass use of tanks; and indeed tanks and particularly armoured cars were making themselves felt on the battlefield. However, cavalry still had its place; the lack of it was one of the factors that limited German success in the spring offensives of 1918. The horse remained the quickest and most reliable means of getting over battle torn ground.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page113.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A working party, encumbered with the equipment to consolidate newly captured positions, moves past a massive British railway gun, mounted on railway lines. These guns had a range of just short of thirty kilometres.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page114_1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("24 November 1917 – The opening days of the Battle of Cambrai, launched against the outer defences of the formidable Hindenburg Line, were generally successful. This was the result of the mass use of tanks but also because of a far more sophisticated artillery fire plan. To be successful such plans required a huge expenditure of shells; and here we see an ammunition column stretching out into the distance, passing heavy guns of the Australian artillery.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page114_2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("British cavalry watering their horses in a village, whilst behind them supply wagons ford the river. The plan for Cambrai called for a breakthrough of the extensive German defences on the right flank of the battle front, with cavalry used to sweep through them and then envelop Cambrai itself. The plan came close to success, but German resistance held and the cavalry could not be used as originally planned.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page115.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("20 November 1917 – Men of a machine gun company have their Vickers guns on standby whilst they take some time to relax in a shallow trench. Although Cambrai started well, there was prolonged and bitter fighting in Bourlon Wood, which dominated the surrounding country. At the very end of November the Germans launched a massive counter offensive, which took back much of the lost ground but, was in turn, something of a disappointment in its outcome for German military planners. Events at Cambrai were significant in determining the strategy of the German army in 1918.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page116.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The central part of the attack faced the German defences before the hill top village of Flesquières; in action with the tanks was the 51st (Highland) Division. They were unfortunate to have facing them a division (the 54th) that had received specialised anti-tank training and, indeed, it had faced French tanks during the Nivelle Offensive in the spring. Nevertheless, even here the Germans were forced to abandon the village on the night of the 20th.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page117.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("A busy scene on a road behind the Cambrai front on 29 November – the day before the German counter-offensive. To the modern eye there is a jarring meeting of old and new methods of war – on the left motor cycle combinations and on the right cavalry. Note that the troopers are, for the most part, leading their horses so as not to tire them.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page118.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Senior NCOs and officers enjoying Christmas cheer as they receive packages, a scene captured by the Official Photographer and designed to raise morale at home. In fact the postal services were remarkably efficient and even perishable foodstuffs usually made it to the soldiers at the front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page119.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("Local civilians in the areas of the front, French and Belgian, were remarkably resilient in the face of war being waged on their doorstep. Many tried to carry on as much as they could as they had before the war; some made money by selling ‘vin plonk’ and chips and omelettes; others had to be forcibly evacuated – a practice much more common on the German side of the line.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page120.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("January 1918 – A desolate winter scene; troops gather around a brazier for warmth whilst wagons, with their drivers well wrapped up, return from making deliveries further forward. By the end of the year Russia had had its second revolution and signed an armistice; whilst the allies had been bolstered by the arrival of American troops in some number on the Western Front; American troops were first killed in action at Cambrai.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page121.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The driver of a water cart uses reins to urge one of his horses to drag itself out of the mud into which it has fallen, having come off a primitive corduroy (i.e. made from tree logs) road. Such roads were commonly used during the war, providing a reasonably solid surface for men and equipment to be moved over a shell-scarred battlefield.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page122.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("A wounded British soldier – a very short man, who may well have been recruited to a bantam battalion – that is battalions that recruited soldiers who were below the regulation height – being accompanied by a German prisoner. The prisoner does not seem to be unhappy about his capture.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page123.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("March 1918 – Exhausted British soldiers snatching some sleep and rest. The Germans launched the first of a series of offensives in March 1918 against the British and French lines, the first of which was against the weakest part of the British line, held by the Fifth Army, on the Somme; and against the Third Army before Arras. Extensive gains in territory were made in the south and caused very heavy casualties (mainly as prisoners). But the line held.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page124.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("The torrential rain returned to Flanders in October, a month in which a series of attacks were launched to clear Broodseinde Ridge and its extension to the north, Passchendaele Ridge. If successful, this would mean that the British had cleared the Germans from the high ground overlooking the Salient from the north and the east.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page125.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("12 October 1917 – Exhausted soldiers shelter in the lee of a railway cutting near Broodseinde Ridge, seemingly oblivious to the dead around them. The First Battle of Passchendaele was fought on this day, mainly by Second Army; very little progress was made and heavy losses were sustained.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page126.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption"
  }, [_vm._v("A gas sentry stands at his post: note the simple wind vane set up in the sand-bagged parapet in front of his elevated position. The sign is reassuring; a gas alarm would be signalled by a variety of means, such as sounding a gong or a siren.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page127.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Food shortages became common amongst all the nations involved in the war in Europe, although this was particularly the case in Germany. The success of the German U-boat campaign in 1917 led to the imposition of rationing at home in the UK, although British troops at the front were, generally, still well fed. The Germans also suffered from shortages in many other supplies, which affected everything from motor transport, medical supplies, and even the quality of the boots on the men’s feet.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page128.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("Battlefield clearance. Here two captured British sergeants are employed by the Germans to search the bodies of (in this case) fallen German soldiers, removing personal effects and establishing identities.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Page129.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "imagecaption1"
  }, [_vm._v("This soldier seems to have found some time for reflection, as he contemplates the body of a soldier laid out by the roadside and ready for burial. The mental stress of life in a combat area must have been considerable and would have a lifelong effect on many of the combatants. The realities of war also separated them from their fellow countrymen, who had very limited experience or understanding of the conditions and of life at the front.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237921fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Chapter_1.vue
// module id = 66
// module chunks = 0